export const fetchJson = url => fetch(url).then(response => response.json())



// WEBPACK FOOTER //
// ./src/utils/fetch.js